import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { EditUserModel } from './user-details.model';
import { UserManagementService } from '../user-management.service';
import { Router } from '@angular/router';
import { EnumModel } from '../../shared/objects/EnumModel';
import { GroupDetailsVenueModel } from '../../venues/create-group/create-group.model';
import { takeUntil } from 'rxjs/operators';
import { UnsubscribeDestroyHelper } from '../../shared/helpers/unsubscribe.helper';

@Component({
  selector: 'app-user-details',
  templateUrl: './user-details.component.html',
  styleUrls: ['./user-details.component.less'],
})
export class UserDetailsComponent extends UnsubscribeDestroyHelper implements OnInit {
  @Input() showUserDetails: boolean;
  @Input() user;
  @Input() fromGroupDatabase: boolean;
  @Input() venues: GroupDetailsVenueModel[];
  @Output() showUserDetailsChange = new EventEmitter<boolean>();
  @Output() editUserChange = new EventEmitter();

  optionsDropdown: EnumModel[] = [];
  selectedOptionDropdown = new EnumModel();
  optionsVenuesDropdown: EnumModel[] = [];
  selectedOptionVenuesDropdown = new EnumModel();
  editUserModel = new EditUserModel();
  buttonsEnabled = true;
  showError = false;
  errorInfo = '';
  focus: boolean;

  constructor(private userManagementService: UserManagementService, private _router: Router) {
    super();
  }

  ngOnInit() {
    if (this.fromGroupDatabase) {
      this.optionsDropdown.push(new EnumModel('GroupDashboard', 'Group Dashboard'));
      this.optionsDropdown.push(new EnumModel('VenueDashboard', 'Venue Dashboard'));
      this.selectedOptionDropdown = this.optionsDropdown[0];

      if (this.user.role === 3) {
        this.selectedOptionDropdown = this.optionsDropdown[1];
        this.editUserModel.isAdmin = true;
      }
      if (this.user.role === 4) {
        this.selectedOptionDropdown = this.optionsDropdown[1];
        this.editUserModel.isAdmin = false;
      }
      if (this.user.role === 5) {
        this.selectedOptionDropdown = this.optionsDropdown[0];
        this.editUserModel.isAdmin = true;
      }
      if (this.user.role === 6) {
        this.selectedOptionDropdown = this.optionsDropdown[0];
        this.editUserModel.isAdmin = false;
      }

      for (const venue of this.venues) {
        this.optionsVenuesDropdown.push(new EnumModel(venue.id.toString(), venue.name));
      }
      this.selectedOptionVenuesDropdown = EnumModel.GetByIdOrFirst(this.optionsVenuesDropdown, this.user.venueId ? this.user.venueId.toString() : '');

    } else {
      this.editUserModel.isAdmin = this.user.isAdmin;
    }

    this.editUserModel.id = this.user.id;
    this.editUserModel.firstName = this.user.firstName;
    this.editUserModel.lastName = this.user.lastName;
    this.editUserModel.email = this.user.email;
    this.editUserModel.isAnalytics = this.user.isAnalytics;
  }

  close() {
    this.showUserDetailsChange.emit(false);
  }

  closeX() {
    if (this.buttonsEnabled) {
      this.showUserDetailsChange.emit(false);
    }
  }

  editUser(isValid: boolean) {
    this.buttonsEnabled = false;

    if (this.editUserModel.newPassword === '' && this.editUserModel.confirmPassword === '') {
      this.editUserModel.newPassword = null;
      this.editUserModel.confirmPassword = null;
    }

    if (this.editUserModel.newPassword !== this.editUserModel.confirmPassword) {
      isValid = false;
      this.showError = true;
      this.errorInfo = 'Please confirm your password!';
    }

    if (isValid) {
      if (this.fromGroupDatabase) {
        if (this.editUserModel.isAdmin) {
          if (this.selectedOptionDropdown.id === 'GroupDashboard') {
            this.editUserModel.role = 5;
          } else {
            this.editUserModel.role = 3;
          }
        } else {
          if (this.selectedOptionDropdown.id === 'GroupDashboard') {
            this.editUserModel.role = 6;
          } else {
            this.editUserModel.role = 4;
          }
        }
      } else {
        if (this.editUserModel.isAdmin) {
          this.editUserModel.role = 1;
        } else {
          this.editUserModel.role = 2;
        }
      }

      this.editUserModel.venueId = this.selectedOptionVenuesDropdown ? this.selectedOptionVenuesDropdown.id : null;

      if (this.fromGroupDatabase) {
        this.editUserChange.emit(this.editUserModel);
        this.close();
      } else {
        this.userManagementService.editUser(this.editUserModel).pipe(
          takeUntil(this.unsubscribeSubject)
        ).subscribe(
            (response) => {
              this.showError = false;
              this.editUserChange.emit('userManagement');
              this.showUserDetailsChange.emit(false);
              this.close();
            },
            (error) => {
              this.buttonsEnabled = true;
              this.showError = true;
              this.errorInfo = error;
            },
          );
      }
    }
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/user-management/user-details/user-details.component.ts